import { RSAA } from 'redux-api-middleware';
import TELEMETRY_API from '../../config/api';

export const POWERBI_REQUEST = 'POWERBI_REQUEST';
export const POWERBI_SUCCESS = 'POWERBI_SUCCESS';
export const POWERBI_FAILURE = 'POWERBI_FAILURE';

export const POWERBI_LOCATION_REQUEST = 'POWERBI_LOCATION_REQUEST';
export const POWERBI_LOCATION_SUCCESS = 'POWERBI_LOCATION_SUCCESS';
export const POWERBI_LOCATION_FAILURE = 'POWERBI_LOCATION_FAILURE';

export const POWERBIDPC_REQUEST = 'POWERBIDPC_REQUEST';
export const POWERBIDPC_SUCCESS = 'POWERBIDPC_SUCCESS';
export const POWERBIDPC_FAILURE = 'POWERBIDPC_FAILURE';

export const POWERBIDPCMEMBERSHIP_REQUEST = 'POWERBIDPCMEMBERSHIP_REQUEST';
export const POWERBIDPCMEMBERSHIP_SUCCESS = 'POWERBIDPCMEMBERSHIP_SUCCESS';
export const POWERBIDPCMEMBERSHIP_FAILURE = 'POWERBIDPCMEMBERSHIP_FAILURE';

export const PATIENT_SATISFACTION_REQUEST = 'PATIENT_SATISFACTION_REQUEST';
export const PATIENT_SATISFACTION_SUCCESS = 'PATIENT_SATISFACTION_SUCCESS';
export const PATIENT_SATISFACTION_FAILURE = 'PATIENT_SATISFACTION_FAILURE';

export const PMD_INTERNAL_DAILY_REQUEST = 'PMD_INTERNAL_DAILY_REQUEST';
export const PMD_INTERNAL_DAILY_SUCCESS = 'PMD_INTERNAL_DAILY_SUCCESS';
export const PMD_INTERNAL_DAILY_FAILURE = 'PMD_INTERNAL_DAILY_FAILURE';

export const PMD_INTERNAL_WEEKLY_REQUEST = 'PMD_INTERNAL_WEEKLY_REQUEST';
export const PMD_INTERNAL_WEEKLY_SUCCESS = 'PMD_INTERNAL_WEEKLY_SUCCESS';
export const PMD_INTERNAL_WEEKLY_FAILURE = 'PMD_INTERNAL_WEEKLY_FAILURE';

export const PMD_INTERNAL_MONTHLY_REQUEST = 'PMD_INTERNAL_MONTHLY_REQUEST';
export const PMD_INTERNAL_MONTHLY_SUCCESS = 'PMD_INTERNAL_MONTHLY_SUCCESS';
export const PMD_INTERNAL_MONTHLY_FAILURE = 'PMD_INTERNAL_MONTHLY_FAILURE';

export const PATIENT_ADVOCATE_REQUEST = 'PATIENT_ADVOCATE_REQUEST';
export const PATIENT_ADVOCATE_SUCCESS = 'PATIENT_ADVOCATE_SUCCESS';
export const PATIENT_ADVOCATE_FAILURE = 'PATIENT_ADVOCATE_FAILURE';

export const HEALTHCENTER_UTILIZATION_REQUEST = 'HEALTHCENTER_UTILIZATION_REQUEST';
export const HEALTHCENTER_UTILIZATION_SUCCESS = 'HEALTHCENTER_UTILIZATION_SUCCESS';
export const HEALTHCENTER_UTILIZATION_FAILURE = 'HEALTHCENTER_UTILIZATION_FAILURE';

export const HEALTHCENTER_DASHBOARD_REQUEST = 'HEALTHCENTER_DASHBOARD_REQUEST';
export const HEALTHCENTER_DASHBOARD_SUCCESS = 'HEALTHCENTER_DASHBOARD_SUCCESS';
export const HEALTHCENTER_DASHBOARD_FAILURE = 'HEALTHCENTER_DASHBOARD_FAILURE';

export const POWERBI_COW_REQUEST = 'POWERBI_COW_REQUEST';
export const POWERBI_COW_SUCCESS = 'POWERBI_COW_SUCCESS';
export const POWERBI_COW_FAILURE = 'POWERBI_COW_FAILURE';

export const POWERBI_SONM_REQUEST = 'POWERBI_SONM_REQUEST';
export const POWERBI_SONM_SUCCESS = 'POWERBI_SONM_SUCCESS';
export const POWERBI_SONM_FAILURE = 'POWERBI_SONM_FAILURE';

export const POWERBI_AC_REQUEST = 'POWERBI_AC_REQUEST';
export const POWERBI_AC_SUCCESS = 'POWERBI_AC_SUCCESS';
export const POWERBI_AC_FAILURE = 'POWERBI_AC_FAILURE';

export const POWERBI_CONMB_REQUEST = 'POWERBI_CONMB_REQUEST';
export const POWERBI_CONMB_SUCCESS = 'POWERBI_CONMB_SUCCESS';
export const POWERBI_CONMB_FAILURE = 'POWERBI_CONMB_FAILURE';

export const POWERBI_PAI_REQUEST = 'POWERBI_PAI_REQUEST';
export const POWERBI_PAI_SUCCESS = 'POWERBI_PAI_SUCCESS';
export const POWERBI_PAI_FAILURE = 'POWERBI_PAI_FAILURE'; 

export const POWERBI_PMD_DEMO_REQUEST = 'POWERBI_PMD_DEMO_REQUEST';
export const POWERBI_PMD_DEMO_SUCCESS = 'POWERBI_PMD_DEMO_SUCCESS';
export const POWERBI_PMD_DEMO_FAILURE = 'POWERBI_PMD_DEMO_FAILURE';

export const EXPORT_TO_PDF_REQUEST = 'EXPORT_TO_PDF_REQUEST';
export const EXPORT_TO_PDF_SUCCESS = 'EXPORT_TO_PDF_SUCCESS';
export const EXPORT_TO_PDF_FAILURE = 'EXPORT_TO_PDF_FAILURE';

export const PG_DASHBOARD_COW_REQUEST = 'PG_DASHBOARD_COW_REQUEST';
export const PG_DASHBOARD_COW_SUCCESS = 'PG_DASHBOARD_COW_SUCCESS';
export const PG_DASHBOARD_COW_FAILURE = 'PG_DASHBOARD_COW_FAILURE';

export const PG_DASHBOARD_MCCSC_REQUEST = 'PG_DASHBOARD_MCCSC_REQUEST';
export const PG_DASHBOARD_MCCSC_SUCCESS = 'PG_DASHBOARD_MCCSC_SUCCESS';
export const PG_DASHBOARD_MCCSC_FAILURE = 'PG_DASHBOARD_MCCSC_FAILURE';

export const PG_DASHBOARD_LL_REQUEST = 'PG_DASHBOARD_LL_REQUEST';
export const PG_DASHBOARD_LL_SUCCESS = 'PG_DASHBOARD_LL_SUCCESS';
export const PG_DASHBOARD_LL_FAILURE = 'PG_DASHBOARD_LL_FAILURE';

export const PATIENT_INSURANCE_REQUEST = 'PATIENT_INSURANCE_REQUEST'; 
export const PATIENT_INSURANCE_SUCCESS = 'PATIENT_INSURANCE_SUCCESS';
export const PATIENT_INSURANCE_FAILURE = 'PATIENT_INSURANCE_FAILURE';

export const PROVIDER_SCORECARD_REQUEST = 'PROVIDER_SCORECARD_REQUEST';
export const PROVIDER_SCORECARD_SUCCESS = 'PROVIDER_SCORECARD_SUCCESS';
export const PROVIDER_SCORECARD_FAILURE = 'PROVIDER_SCORECARD_FAILURE';

export const PATIENT_ELIGIBILITY_REQUEST = 'PATIENT_ELIGIBILITY_REQUEST'; 
export const PATIENT_ELIGIBILITY_SUCCESS = 'PATIENT_ELIGIBILITY_SUCCESS';
export const PATIENT_ELIGIBILITY_FAILURE = 'PATIENT_ELIGIBILITY_FAILURE';

export const REFERRAL_DASHBOARD_REQUEST = 'REFERRAL_DASHBOARD_REQUEST';
export const REFERRAL_DASHBOARD_SUCCESS = 'REFERRAL_DASHBOARD_SUCCESS';
export const REFERRAL_DASHBOARD_FAILURE = 'REFERRAL_DASHBOARD_FAILURE';

export const GOOGLE_MAP_REQUEST = 'GOOGLE_MAP_REQUEST';
export const GOOGLE_MAP_SUCCESS = 'GOOGLE_MAP_SUCCESS';
export const GOOGLE_MAP_FAILURE = 'GOOGLE_MAP_FAILURE';

export function requestClientReport() {
  return {
    [RSAA]: {
      endpoint: `${TELEMETRY_API}organization/power-bi/client-report`,
      method: 'GET',
      types: ['POWERBI_REQUEST', 'POWERBI_SUCCESS', 'POWERBI_FAILURE'],
    }
  };
}

export function requestLocationReport() {
  return {
    [RSAA]: {
      endpoint: `${TELEMETRY_API}organization/power-bi/location-report`,
      method: 'GET',
      types: ['POWERBI_LOCATION_REQUEST', 'POWERBI_LOCATION_SUCCESS', 'POWERBI_LOCATION_FAILURE'],
    }
  };
}

export function requestDpcClientReport() {
  return {
    [RSAA]: {
      endpoint: `${TELEMETRY_API}organization/power-bi/dpc-client-report`,
      method: 'GET',
      types: ['POWERBIDPC_REQUEST', 'POWERBIDPC_SUCCESS', 'POWERBIDPC_FAILURE'],
    }
  };
}

export function requestDpcMembershipDashboard() {
  return {
    [RSAA]: {
      endpoint: `${TELEMETRY_API}organization/power-bi/dpc-membership-dashboard`,
      method: 'GET',
      types: ['POWERBIDPCMEMBERSHIP_REQUEST', 'POWERBIDPCMEMBERSHIP_SUCCESS', 'POWERBIDPCMEMBERSHIP_FAILURE'],
    }
  };
}

export function requestPatientSatisfactionReport() {
  return {
    [RSAA]: {
      endpoint: `${TELEMETRY_API}organization/power-bi/patient-satisfaction-report`,
      method: 'GET',
      types: ['PATIENT_SATISFACTION_REQUEST', 'PATIENT_SATISFACTION_SUCCESS', 'PATIENT_SATISFACTION_FAILURE'],
    }
  };
}

export function requestPMDInternalDailyReport() {
  return {
    [RSAA]: {
      endpoint: `${TELEMETRY_API}organization/power-bi/pmd-internal-daily-report`,
      method: 'GET',
      types: ['PMD_INTERNAL_DAILY_REQUEST', 'PMD_INTERNAL_DAILY_SUCCESS', 'PMD_INTERNAL_DAILY_FAILURE'],
    }
  };
}

export function requestPMDInternalWeeklyReport() {
  return {
    [RSAA]: {
      endpoint: `${TELEMETRY_API}organization/power-bi/pmd-internal-weekly-report`,
      method: 'GET',
      types: ['PMD_INTERNAL_WEEKLY_REQUEST', 'PMD_INTERNAL_WEEKLY_SUCCESS', 'PMD_INTERNAL_WEEKLY_FAILURE'],
    }
  };
}

export function requestPMDInternalMonthlyReport() {
  return {
    [RSAA]: {
      endpoint: `${TELEMETRY_API}organization/power-bi/pmd-internal-monthly-report`,
      method: 'GET',
      types: ['PMD_INTERNAL_MONTHLY_REQUEST', 'PMD_INTERNAL_MONTHLY_SUCCESS', 'PMD_INTERNAL_MONTHLY_FAILURE'],
    }
  };
}

export function requestPatientAdvocateDashboard() {
  return {
    [RSAA]: {
      endpoint: `${TELEMETRY_API}organization/power-bi/patient-advocate-dashboard`,
      method: 'GET',
      types: ['PATIENT_ADVOCATE_REQUEST', 'PATIENT_ADVOCATE_SUCCESS', 'PATIENT_ADVOCATE_FAILURE'],
    }
  };
}

export function requestHealthCenterUtilizationReport() {
  return {
    [RSAA]: {
      endpoint: `${TELEMETRY_API}organization/power-bi/healthcenter-utilization-report`,
      method: 'GET',
      types: ['HEALTHCENTER_UTILIZATION_REQUEST', 'HEALTHCENTER_UTILIZATION_SUCCESS', 'HEALTHCENTER_UTILIZATION_FAILURE'],
    }
  };
}

export function requestHealthCenterDashboardReport() {
  return {
    [RSAA]: {
      endpoint: `${TELEMETRY_API}organization/power-bi/healthcenter-dashboard-report`,
      method: 'GET',
      types: ['HEALTHCENTER_DASHBOARD_REQUEST', 'HEALTHCENTER_DASHBOARD_SUCCESS', 'HEALTHCENTER_DASHBOARD_FAILURE'],
    }
  };
}

export function requestCOWClientDashboardReport() {
  return {
    [RSAA]: {
      endpoint: `${TELEMETRY_API}organization/power-bi/cow-client-dashboard`,
      method: 'GET',
      types: ['POWERBI_COW_REQUEST', 'POWERBI_COW_SUCCESS', 'POWERBI_COW_FAILURE'],
    }
  };
}

export function requestSONMClientDashboardReport() {
  return {
    [RSAA]: {
      endpoint: `${TELEMETRY_API}organization/power-bi/sonm-client-dashboard`,
      method: 'GET',
      types: ['POWERBI_SONM_REQUEST', 'POWERBI_SONM_SUCCESS', 'POWERBI_SONM_FAILURE'],
    }
  };
}

export function requestACClientDashboardReport() {
  return {
    [RSAA]: {
      endpoint: `${TELEMETRY_API}organization/power-bi/ac-client-dashboard`,
      method: 'GET',
      types: ['POWERBI_AC_REQUEST', 'POWERBI_AC_SUCCESS', 'POWERBI_AC_FAILURE'],
    }
  };
}

export function requestCONMBClientDashboardReport() {
  return {
    [RSAA]: {
      endpoint: `${TELEMETRY_API}organization/power-bi/conmb-client-dashboard`,
      method: 'GET',
      types: ['POWERBI_CONMB_REQUEST', 'POWERBI_CONMB_SUCCESS', 'POWERBI_CONMB_FAILURE'],
    }
  };
}

export function requestPAIClientReport() {
  return {
    [RSAA]: {
      endpoint: `${TELEMETRY_API}organization/power-bi/pai-client-report`,
      method: 'GET',
      types: ['POWERBI_PAI_REQUEST', 'POWERBI_PAI_SUCCESS', 'POWERBI_PAI_FAILURE'],
    }
  };
}

export function requestPMDDemoClientReport() {
  return {
    [RSAA]: {
      endpoint: `${TELEMETRY_API}organization/power-bi/pmd-demo-client-report`,
      method: 'GET',
      types: ['POWERBI_PMD_DEMO_REQUEST', 'POWERBI_PMD_DEMO_SUCCESS', 'POWERBI_PMD_DEMO_FAILURE'],
    }
  };
}

export function requestExportToPDF(reportId) {
  return {
    [RSAA]: {
      endpoint: `${TELEMETRY_API}organization/power-bi/export/${reportId}`,
      method: 'GET',
      headers: {},
      types: [
        'EXPORT_TO_PDF_REQUEST',
        {
          type: 'EXPORT_TO_PDF_SUCCESS',
          payload: (action, state, res) => {
            return res.blob();
          }
        },
        'EXPORT_TO_PDF_FAILURE']
    },
  };
}

export function requestPGDashboardCOW() {
  return {
    [RSAA]: {
      endpoint: `${TELEMETRY_API}organization/power-bi/pg-dashboard-cow`,
      method: 'GET',
      types: ['PG_DASHBOARD_COW_REQUEST', 'PG_DASHBOARD_COW_SUCCESS', 'PG_DASHBOARD_COW_FAILURE'],
    }
  };
}

export function requestPGDashboardMCCSC() {
  return {
    [RSAA]: {
      endpoint: `${TELEMETRY_API}organization/power-bi/pg-dashboard-mccsc`,
      method: 'GET',
      types: ['PG_DASHBOARD_MCCSC_REQUEST', 'PG_DASHBOARD_MCCSC_SUCCESS', 'PG_DASHBOARD_MCCSC_FAILURE'],
    }
  };
}

export function requestPGDashboardLL() {
  return {
    [RSAA]: {
      endpoint: `${TELEMETRY_API}organization/power-bi/pg-dashboard-lnl`,
      method: 'GET',
      types: ['PG_DASHBOARD_LL_REQUEST', 'PG_DASHBOARD_LL_SUCCESS', 'PG_DASHBOARD_LL_FAILURE'],
    }
  };
}

export function requestPatientInsuranceReport() {
  return {
    [RSAA]: {
      endpoint: `${TELEMETRY_API}organization/power-bi/patient-insurance-report`,
      method: 'GET',
      types: ['PATIENT_INSURANCE_REQUEST', 'PATIENT_INSURANCE_SUCCESS', 'PATIENT_INSURANCE_FAILURE'],
    }
  };
}

export function requestProviderScorecardReport() {
  return {
    [RSAA]: {
      endpoint: `${TELEMETRY_API}organization/power-bi/provider-scorecard-report`,
      method: 'GET',
      types: ['PROVIDER_SCORECARD_REQUEST', 'PROVIDER_SCORECARD_SUCCESS', 'PROVIDER_SCORECARD_FAILURE'],
    }
  };
}

export function requestPatientEligibilityReport() {
  return {
    [RSAA]: {
      endpoint: `${TELEMETRY_API}organization/power-bi/patient-eligibility-report`,
      method: 'GET',
      types: ['PATIENT_ELIGIBILITY_REQUEST', 'PATIENT_ELIGIBILITY_SUCCESS', 'PATIENT_ELIGIBILITY_FAILURE'],
    }
  };
}

export function requestReferralDashboardReport() {
  return {
    [RSAA]: {
      endpoint: `${TELEMETRY_API}organization/power-bi/referral-dashboard-report`,
      method: 'GET',
      types: ['REFERRAL_DASHBOARD_REQUEST', 'REFERRAL_DASHBOARD_SUCCESS', 'REFERRAL_DASHBOARD_FAILURE'],
    }
  };
}

export function requestGoogleMapReport() {
  return {
    [RSAA]: {
      endpoint: `${TELEMETRY_API}organization/power-bi/google-map-report`,
      method: 'GET',
      types: ['GOOGLE_MAP_REQUEST', 'GOOGLE_MAP_SUCCESS', 'GOOGLE_MAP_FAILURE'],
    }
  };
}



// WEBPACK FOOTER //
// ./src/store/power-bi/PowerBiActions.js